import { Grid, Box, Typography } from '@mui/material';

import Backdrop from '@mui/material/Backdrop';
import Alert from '@mui/material/Alert';    

const InfoMessage = ({children}) => {
    return (
        // <Grid container sx={{alignItems:'center', display:'flex', justifyContent:'center'}}>
        //     <Box>
        //         <Typography variant='h1'>Error Page </Typography>
        //     </Box>
        // </Grid>
        <Backdrop
        sx={{flexDirection:'column',gap:'1rem', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <Box sx={{display:"flex",alignItems:"center",justifyContent:"center",gap:"2rem",backgroundColor:"#ffffff",borderRadius:"0.5rem",borderTop:"2.5rem solid #cf2030", minHeight:"20rem", minWidth:"50rem", padding:"0 1.5rem"}}>{children}</Box>
       
      </Backdrop> 
    );
};

export default InfoMessage;